import { useEffect, useState } from "react"
import { Navbar, Nav, Container, Dropdown } from "react-bootstrap"
import { Cart4 } from "react-bootstrap-icons"
import { PUBLIC_URL } from "../serviceWorker"
import { useDispatch, useSelector } from "react-redux"
import { fetchCart, resetClient } from "../actions/cartActions"
import { fetchShop, setLogin } from "../actions/shopActions"
import { RootState } from "../reducers"
import AlertOutStock from "./AlertOutStock"
import SearchProducts from "./SearchProducts"
import { useNavigate, useLocation } from "react-router-dom"

const Navigation = () => {
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
  const itemsCart = useSelector((state: RootState) => state.cart.itemsCart)
  const productTypes = useSelector(
    (state: RootState) => state.shop.product_types
  )
  const isLogued = useSelector((state: RootState) => state.shop.isLogued);
  const dispatch: any = useDispatch()
  const style = { color: "#212529", fontSize: "1.2rem", textDecoration: "none" }
  const [sizes, setSizes] = useState([] as any)
  const navigate: any = useNavigate()
  const cellPhoneStorage = localStorage.getItem('cell_phone')
  const clientIdStorage = localStorage.getItem('client_id')
  const location = useLocation()
  const pathname = location.pathname.split('/')

  useEffect(() => {
    dispatch(fetchCart())
    dispatch(fetchShop())
    const container = document.getElementById("container")
    if (container)
      container.addEventListener("click", () => {
        setDropdownIsOpen(false)
      })
  }, [dispatch])

  useEffect(() => {
    const sizes = productTypes.filter((item: any) => item.name.includes("Talle"))
    sizes.sort(sizesSort)
    setSizes(sizes)
  }, [productTypes])

  useEffect(() => {
    if (cellPhoneStorage && clientIdStorage) {
      dispatch(setLogin({ isLogued: true }))
    }
  }, [cellPhoneStorage, clientIdStorage, dispatch, isLogued])

  const onLogout = () => {
    dispatch(resetClient())
    dispatch(setLogin({ isLogued: false }))
  }

  const sizesSort = (a: { name: string }, b: { name: string }) => {
    const numA = parseInt(a.name.replace('Talle ', ''));
    const numB = parseInt(b.name.replace('Talle ', ''));
    return numA - numB;
  }

  return <Navbar
    expand="lg"
    variant="light"
    className="mb-3 justify-content-between"
    expanded={dropdownIsOpen}
    onToggle={() => setDropdownIsOpen(!dropdownIsOpen)}
    style={{ backgroundColor: "#d2fb1a", color: "#000" }}
  >
    <Container fluid>
      <Navbar.Brand
        onClick={() => {
          navigate("/")
          setDropdownIsOpen(false)
        }}
      >
        <img
          alt="Newton"
          src={PUBLIC_URL + "img/user/1/header.png"}
          height="45"
        />
      </Navbar.Brand>
      {itemsCart > 0 && (
        <Nav.Link
          onClick={() => {
            navigate("/cart")
            setDropdownIsOpen(false)
          }}
          className="p-0 me-2"
          style={style}
        >
          <Cart4 className="me-1" size={25} />
          {itemsCart}
        </Nav.Link>
      )}
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <SearchProducts />
        <Nav.Link
          className="ms-3 me-3"
          onClick={() => {
            navigate("/")
            setDropdownIsOpen(false)
          }}
          style={style}
        >
          Inicio
        </Nav.Link>
        <Nav.Link
          className="ms-3 me-3"
          onClick={() => {
            navigate("/my-orders")
            setDropdownIsOpen(false)
          }}
          style={style}
        >
          Mis pedidos
        </Nav.Link>
        {location.pathname !== '/' &&
          <Dropdown>
            <Dropdown.Toggle style={style} variant="link" id="dropdown-basic">
              Talles
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {sizes?.length > 0 &&
                sizes.map((item: any, index: number) => (
                  <Dropdown.Item
                    key={index}
                    style={style}
                    onClick={() => {
                      navigate(`${pathname[1]}/${pathname[2]}/${item.id}`)
                      setDropdownIsOpen(false)
                    }}
                  >
                    {item.name}
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>}
        <Dropdown>
          <Dropdown.Toggle style={style} variant="link" id="dropdown-basic">
            Como comprar
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              style={style}
              onClick={() => {
                navigate("/howtobuy")
                setDropdownIsOpen(false)
              }}
            >
              Pasos a seguir
            </Dropdown.Item>
            <Dropdown.Item
              style={style}
              onClick={() => {
                navigate("/howtopay")
                setDropdownIsOpen(false)
              }}
            >
              Formas de pago
            </Dropdown.Item>
            <Dropdown.Item
              style={style}
              onClick={() => {
                navigate("/sends")
                setDropdownIsOpen(false)
              }}
            >
              Envío
            </Dropdown.Item>
            <Dropdown.Item
              style={style}
              onClick={() => {
                navigate("/changes")
                setDropdownIsOpen(false)
              }}
            >
              Política de cambios
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Nav.Link
          className="ms-3 me-3"
          onClick={() => {
            navigate("/contact")
            setDropdownIsOpen(false)
          }}
          style={style}
        >
          Contacto
        </Nav.Link>
        {isLogued && <Nav.Link
          className="ms-3 me-3"
          onClick={() => {
            navigate("/")
            setDropdownIsOpen(false)
            onLogout()
          }}
          style={style}
        >
          Salir
        </Nav.Link>}
      </Navbar.Collapse>
    </Container>
    <AlertOutStock />
  </Navbar>
}

export default Navigation
